import { Ionicons } from '@expo/vector-icons';
import { router } from 'expo-router';
import React from 'react';
import { View } from 'react-native';

import { ThemedText } from '@/components/themed-text';
import { PressableScale } from '@/components/ui/pressable-scale';
import { useMembership } from '@/hooks/use-membership';
import { useProviderProfile } from '@/hooks/use-provider';
import { useTerms } from '@/hooks/use-terms';

/**
 * Primeiro passo do profissional numa equipe "cada um por si": a cobrança do
 * cliente dele sai com os dados dele, então sem Pix nem link ela sai vazia.
 * Some sozinho quando o dado aparece.
 *
 * O "Conecte seu WhatsApp" do plano fica de fora enquanto o card de conexão
 * estiver desligado no Perfil — hoje tudo sai pelo número da ControlaPag.
 */
export function ProfessionalSetupCard() {
  const { isProfessional, modes } = useMembership();
  const needsOwnPayment = isProfessional && modes?.paymentMode === 'PROFESSIONAL';
  const { data: provider } = useProviderProfile({ enabled: needsOwnPayment });
  const terms = useTerms();

  if (!needsOwnPayment || !provider) return null;
  if (provider.defaultPixCopyPaste || provider.defaultPaymentLink) return null;

  return (
    <View
      className="flex-row items-center gap-3 rounded-2xl border border-neutral-900/5 bg-card p-4"
      style={{ borderCurve: 'continuous' }}
    >
      <View className="h-10 w-10 items-center justify-center rounded-full bg-primary/10 dark:bg-primary">
        <Ionicons className="text-primary dark:text-white" name="qr-code-outline" size={18} />
      </View>
      <View className="min-w-0 flex-1 gap-0.5">
        <ThemedText className="font-semibold text-sm text-neutral-900">Cadastre seu Pix</ThemedText>
        <ThemedText className="text-xs text-neutral-500">
          {`Suas cobranças saem com os seus dados, não com os ${terms.agree('do', 'organization')} ${terms.organization}.`}
        </ThemedText>
      </View>
      <PressableScale
        haptic
        onPress={() => router.push('/(tabs)/(provider)/profile' as never)}
        className="h-9 items-center justify-center rounded-full bg-primary px-4"
      >
        <ThemedText className="font-bold text-xs text-white">Cadastrar</ThemedText>
      </PressableScale>
    </View>
  );
}
